<template>
<div class="inner-wrapper add-customer-section">
   <div class="page-title mb-3">
      <a  href="javascript:void(0)"  @click="$router.go(-1)"  class="btn custom-btn active" style="font-size: 26px; line-height: 26px; padding: 4px 8px 1px;"><i  class="ri-arrow-left-s-line"></i></a>

   </div>

    <CustomerDetail :customerData="customerData"  ref="CustomerDetail"
    ></CustomerDetail>

        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import CustomerDetail from "../../components/CustomerDetails";
export default {
    name: "CustomerView",
    components: {
        CustomerDetail
    },
    created() {
        this.getCustomer();
    },
    data(){
        return {
            customerData: {
                customer: null,
                country_data: null,
                customer_contact: null,
                can_add_customer: false,
                can_edit_customer: false,
                can_delete_customer: false,
                user_type: null,
                role: null
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        getCustomer() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('customers.show', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                         this.customerData= data.data;
                         console.log("check datatttttt ",this.customerData);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.customerData.config['start_from']) + index;
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
